<script setup lang="ts">
import { ref } from 'vue'
import { useHTTP } from '@/plugins/http'
import { Role } from '@/models/user/Role'
import { Route } from '@/router/routes'
import { useRouter } from 'vue-router'
import RoleForm from '@/views/hr/roles/RoleForm.vue'
import { useI18n } from 'vue-i18n'

const http = useHTTP()
const router = useRouter()
const { t } = useI18n({
  messages: {
    en: {
      roleCreated: 'Role was created successfully'
    },
    ar: {
      roleCreated: 'تم انشاء المنصب بنجاح'
    }
  }
})

const role = ref(new Role('', '', []))

const postRole = async (role: Role) => {
  try {
    await http.post<Role>(Role.ENDPOINT, role)
    await router.push(Route.HR_ROLES)
  } catch (errorResp) {
    return errorResp
  }
}
</script>

<template>
  <role-form :submit-action="postRole" :init-role="role" :successMsg="t('roleCreated')" />
</template>

<style scoped></style>
